exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applicant-card[data-v-647c0a1c]{border-left:4px solid #1976d2!important}.section-heading[data-v-647c0a1c]{display:flex;align-items:center;margin-bottom:12px}.candidate-option[data-v-647c0a1c]{min-width:520px}.selected-member[data-v-647c0a1c]{max-width:100%}@media (max-width:600px){.candidate-option[data-v-647c0a1c]{min-width:280px}}", ""]);

// exports
